import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import { MAPS_SUMMARIES_GENERATE } from './maps-graphql/queries';
import type { MapsSummariesResult } from '../models/maps.types';

/**
 * Wraps the single `mapsSummariesGenerate` mutation (TRD §3.7). Block-and-
 * return: one round-trip per search, no streaming. The page component patches
 * all cards in one pass when this resolves.
 */
@Injectable({ providedIn: 'root' })
export class SummaryService {
    constructor(private readonly apollo: Apollo) {}

    async Generate(searchId: string): Promise<MapsSummariesResult> {
        const t0 = performance.now();
        const result = await firstValueFrom(
            this.apollo.mutate<{ mapsSummariesGenerate: MapsSummariesResult }>({
                mutation: MAPS_SUMMARIES_GENERATE,
                variables: { searchId },
            })
        );
        console.log('[maps.summaries] resolved', {
            ms: Math.round(performance.now() - t0),
            meta: result.data?.mapsSummariesGenerate?.meta,
        });
        if (!result.data?.mapsSummariesGenerate) {
            throw new Error('mapsSummariesGenerate returned empty payload');
        }
        return result.data.mapsSummariesGenerate;
    }
}
